import { MatDialog } from "@angular/material/dialog";
import { Observable, Subject } from "rxjs";
import { MessageBoxComponent } from "./message-box.component";
import { Injectable } from "@angular/core";
import { Buttons, Button } from "./message-box.module";

@Injectable()
export class MessageBox {
  constructor(private dialog: MatDialog) {
  }

  private dialogResultSubject!: Subject<Button>;
  dialogResult$!: Observable<Button>;

  show(message: string, title?: string, buttons?: Buttons, videoLink?: string, moreInfoLink?: string): MessageBox {

    let dialogRef = this.dialog.open(MessageBoxComponent, {
        data: {
          message,
          title,
          buttons: buttons ?? Buttons.Ok, 
          videoLink: videoLink, 
          moreInfoLink: moreInfoLink
        }
      }
    );

    this.dialogResultSubject = new Subject<Button>();
    this.dialogResult$ = this.dialogResultSubject.asObservable()

    dialogRef.componentInstance.dialogResult$.subscribe(pressedButton => {
      this.dialogResultSubject.next(pressedButton);
      this.dialogResultSubject.complete();
      dialogRef.close();
    });

    return this;
  }
}